export const timeFormat = (time) => {
	const date = new Date(time).toString().split(" ").slice(1, 5);
	let hour = date[3].split(":");
	hour = hour[0] + ":" + hour[1];
	date[3] = "at";
	date[4] = hour;
	return date.join(" ");
};
export const trimmedText = (text, limit) => {
	let res = "";
	let flag = false;
	for (let i = 0; i < text.length; ++i) {
		if (i > limit) {
			flag = true;
			break;
		}
		res += text[i];
	}
	if (flag) return res + "...";
	return res;
};
